var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('router-view'),_c('router-view',{attrs:{"name":"appBar"}}),_c('router-view',{attrs:{"name":"lefNavBar"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }